import { Button } from "@material-ui/core";
import React from "react";
import { Spinner } from "./Spinner";

export const LoadingButton = ({ children, loading = false, ...rest }) => (
  <Button color="primary" variant="outlined" disabled={loading} {...rest}>
    {loading ? <Spinner /> : children}
  </Button>
);
